var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.924,
    height: 62.924,
    viewBox: "0 0 62.924 62.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-js"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-js-2",
    "data-name": "Icon awesome-js",
    d: "M0,2.25V65.174H62.924V2.25ZM34.243,51.325c0,6.124-3.6,8.919-8.835,8.919a9.186,9.186,0,0,1-8.877-5.408l4.818-2.907c.927,1.643,1.77,3.034,3.806,3.034,1.938,0,3.174-.758,3.174-3.722v-20.1h5.913Zm13.989,8.919c-5.492,0-9.045-2.612-10.773-6.04l4.818-2.781c1.264,2.065,2.921,3.6,5.829,3.6,2.444,0,4.017-1.222,4.017-2.921,0-2.023-1.6-2.739-4.312-3.933l-1.475-.632c-4.27-1.812-7.093-4.1-7.093-8.919,0-4.438,3.385-7.809,8.652-7.809,3.764,0,6.461,1.306,8.4,4.733l-4.607,2.95c-1.011-1.812-2.107-2.528-3.806-2.528a2.567,2.567,0,0,0-2.823,2.528c0,1.77,1.1,2.486,3.638,3.6l1.475.632c5.028,2.149,7.851,4.354,7.851,9.3,0,5.309-4.186,8.231-9.79,8.231Z",
    transform: "translate(0 -2.25)",
    fill: "#006151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-js)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-js-3",
    "data-name": "Icon awesome-js",
    d: "M0,2.25V65.174H62.924V2.25ZM34.243,51.325c0,6.124-3.6,8.919-8.835,8.919a9.186,9.186,0,0,1-8.877-5.408l4.818-2.907c.927,1.643,1.77,3.034,3.806,3.034,1.938,0,3.174-.758,3.174-3.722v-20.1h5.913Zm13.989,8.919c-5.492,0-9.045-2.612-10.773-6.04l4.818-2.781c1.264,2.065,2.921,3.6,5.829,3.6,2.444,0,4.017-1.222,4.017-2.921,0-2.023-1.6-2.739-4.312-3.933l-1.475-.632c-4.27-1.812-7.093-4.1-7.093-8.919,0-4.438,3.385-7.809,8.652-7.809,3.764,0,6.461,1.306,8.4,4.733l-4.607,2.95c-1.011-1.812-2.107-2.528-3.806-2.528a2.567,2.567,0,0,0-2.823,2.528c0,1.77,1.1,2.486,3.638,3.6l1.475.632c5.028,2.149,7.851,4.354,7.851,9.3,0,5.309-4.186,8.231-9.79,8.231Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.6f2b6d255b6c5bd8c8e5c79f920eff2f.svg";
export { ForwardRef as ReactComponent };